export default {
  toasts: {
    failed_to_create_website: 'Failed to create website',
  },
  steps: {
    information: 'Information',
    template: 'Template',
  },
  buttons: {
    next: 'Next',
    previous: 'Previous',
    create_website: 'Create Website',
    preview_about_us: 'About Us (Preview)',
  },
  about_us_modal: {
    title: 'About Us (Preview)',
  },
  error_messages: {
    missing_fields: 'Some required fields are missing. Please fill in all necessary information before proceeding.',
  },
};
